import { render } from "./DefH2.vue?vue&type=template&id=a4f332ce&scoped=true"
import script from "./DefH2.vue?vue&type=script&lang=js"
export * from "./DefH2.vue?vue&type=script&lang=js"

import "./DefH2.vue?vue&type=style&index=0&id=a4f332ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f332ce"]])

export default __exports__